import { render, staticRenderFns } from "./NameServerSelect.vue?vue&type=template&id=29416afa&"
import script from "./NameServerSelect.vue?vue&type=script&lang=js&"
export * from "./NameServerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAutocomplete,VChip})
